import type { DistributionRequestDto } from 'korint-sdk';
import type { RedirectRules } from 'korint-sdk/react';

export const readsDistributionRequests = (rules: RedirectRules | undefined): boolean =>
  Boolean(rules?.hasPendingDistributionRequest || rules?.noDistributionRequest);

export function getRedirectUrl(
  rules: RedirectRules,
  params: {
    userProducts: string[];
    distributionRequests: DistributionRequestDto[];
    brokerageFirmId: string;
    policyId: string;
    customerId: string;
  },
): string {
  if (params.userProducts.length > 0 && rules.hasUserProducts) {
    return rules.hasUserProducts;
  }
  if (
    params.distributionRequests.some(
      d => d.status === 'PENDING' || d.status === 'WAITING_FOR_SIGNATURE',
    ) &&
    rules.hasPendingDistributionRequest
  ) {
    return rules.hasPendingDistributionRequest;
  }
  if (params.distributionRequests.length === 0 && rules.noDistributionRequest) {
    return rules.noDistributionRequest(params.brokerageFirmId);
  }
  return rules.default(params.policyId);
}
